/**
 * 弹层类
 */
import {
    ElNotification,
    ElMessage,
    ElMessageBox,
    ElLoading
} from 'element-plus';

/**
 * 消息提示
 * @param message
 * @param options
 */
export const alert = function (message, options) {
    let default_options = {
        title: '',
        message
    }
    return ElMessageBox.alert(Object.assign({}, default_options, options));
}

/**
 * 确认消息
 * @param message
 * @param options
 */
export const confirm = function (options) {
    return ElMessageBox.confirm(options.message, options.title || '确认', {
        confirmButtonText: options.confirmButtonText || '确定',
        cancelButtonText: options.cancelButtonText || '取消',
        type: options.type || 'warning',
        beforeClose: options.beforeClose, // 可以在这里添加关闭前的钩子
    }).then(() => {
        if (options.onConfirm) {
            options.onConfirm(); // 确认按钮点击后的操作
        }
    }).catch(() => {
        if (options.onCancel) {
            options.onCancel(); // 取消按钮点击后的操作
        }
    });
}


/**
 * 加载
 * @param options
 */
export const loading = function (message, options) {
    let default_options = {
        lock: true,
        text: message,
        background: 'rgba(0, 0, 0, 0.7)',
    };
    return ElLoading.service(Object.assign({}, default_options, options));
}

/**
 * 消息提示
 * @param message
 * @param options
 */
export const toast = function (message, options) {
    let default_options = {
        message,
        type: 'success'
    };
    return ElMessage(Object.assign({}, default_options, options));
}

/**
 * 消息通知
 * @param message
 * @param options
 */
export const notice = function (message, options) {
    let default_options = {
        message
    };
    return ElNotification(Object.assign({}, default_options, options));
}